export function initializeTheme() {
  // Ensure light mode is always applied
  if (typeof document !== "undefined") {
    document.documentElement.classList.remove("dark")
    document.documentElement.style.colorScheme = "light"
  }
}
